import React from 'react';

export default function SettingsPage() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">Settings</h1>
      <p>Settings page not implemented yet.</p>
    </div>
  );
}